module.exports = __webpack_public_path__ + "img/img_gift.46ba1299.png";